// The unsolicited application is the vacancy Mindkey flags as unsolicited, if the customer has made it public
export const isPublicUnsolicitedApplication = (vacancy: Mindkey.VacancySimple): boolean => vacancy.unsolicited && vacancy.externalAccess !== false;
